<template>
  <div class="field-number" v-if="isVisible">
    <input :id="'form-' + field.form_key" class="form-control"
           type="number"
           :min="min" :max="max" :step="step"
           v-model="answer"
           :tabIndex="question.id"
           :placeholder="field.placeholder || ''"
           autocomplete="on"
           :ref="'field_' + field.form_key"
           :name="'field_' + field.form_key"
           @focus="$emit('questionSelected', question.order)"
      >
  </div>
</template>
<script>

  import elementMixins from '../mixins/elements'

  export default {
    name: 'LUNumber',
    mixins: [elementMixins],

    data: function () {
      return {
        min: 1,
        max: 100,
        step: 1
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Number.vue